import React from "react";
import ImageBanner from "@/components/ImageBanner";
import Card from "@/components/Card";
import Footer from "@/layout/Footer";
import ImageTextSection from "@/components/ImageTextSection";
const BlogDetails = () => {
	const interestingArticles = [
		{
			imageSrc: "assets/success-stories/xl/interestingArticles/image1.svg",
			title: `Unleashing Potential:\nA Trailblazing Journey with\nRetail Arbitrage Dropshipping.`,
			description:
				"In the dynamic world of e-commerce, taking opportunities and optimizing operations are essential for success.",
			date: "29 Aug, 2024",
			buttonText: "Read More",
		},
		{
			imageSrc: "assets/success-stories/xl/interestingArticles/image2.svg",
			title: `Accelerating Growth:\nA Success Story with Retail\nArbitrage Dropshipping.`,
			description:
				"Discover how strategic planning and dedication turned a side hustle into a 6-figure business.",
			date: "15 Sep, 2024",
			buttonText: "Read More",
		},
	];

	return (
		<>
			<div className="relative flex flex-col hidden lg:flex w-full h-auto items-center justify-center mt-[40px]">
				<div className="w-full max-w-[1440px] flex items-center justify-between px-8">
					<ImageBanner
						type="desktop"
						title="Article"
						containerWidth="w-full max-w-[1440px] flex items-center"
						titlePosition={{ top: "top-[100px]", left: "left-[60px]" }}
					/>
				</div>
			</div>
			<div className="w-full max-w-[1300px] mx-auto rounded-[5px] hidden lg:flex flex-col gap-2 mt-4">
				{/* Row 1: Back + Breadcrumbs */}
				<div className="flex flex-row items-center gap-2">
					{/* Back button */}
					<div className="w-[72px] h-[32px] flex flex-row items-center justify-center gap-[4px] px-[8px]">
						<img
							loading="lazy"
							decoding="async"
							src="/assets/blog-details/arrow.svg"
							alt="Back"
							className="w-[16px] h-[16px]"
						/>
						<span className="font-montserrat text-[13px] font-medium leading-[24px] text-center">
							Back
						</span>
					</div>

					{/* Breadcrumbs */}
					<div className="flex flex-row items-center gap-2 h-[32px]">
						<div className="flex flex-row items-center gap-1 px-1">
							<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black">
								Electronic
							</span>
							<img
								loading="lazy"
								decoding="async"
								src="/assets/search/Icons/bread_crum_arrow.svg"
								alt="Electronic"
								className="w-[10px] h-[10px]"
							/>
						</div>

						<div className="flex flex-row items-center gap-1 px-1">
							<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black">
								Gadgets
							</span>
							<img
								loading="lazy"
								decoding="async"
								src="/assets/search/Icons/bread_crum_arrow.svg"
								alt="Gadgets"
								className="w-[10px] h-[10px]"
							/>
						</div>

						<div className="flex flex-row items-center gap-1 px-1">
							<span className="font-montserrat text-[12px] font-normal leading-[100%] text-black whitespace-nowrap">
								Smart Watches
							</span>
							<img
								loading="lazy"
								decoding="async"
								src="/assets/search/Icons/bread_crum_arrow.svg"
								alt="Smart Watches"
								className="w-[10px] h-[10px]"
							/>
						</div>
					</div>
				</div>

				{/* Row 2: Headings */}
				<div className="ml-[8px] flex flex-col gap-2">
					<h1 className="font-montserrat font-extrabold text-[30px] leading-[100%] tracking-[0%] text-[#193D34]">
						Discovering Retail Arbitrage Dropshipping:
					</h1>
					<h1 className="font-montserrat font-extrabold text-[30px] leading-[100%] tracking-[0%] text-[#193D34]">
						Leveraging Data-Driven Insights
					</h1>
				</div>

				{/* Row 3: Date + Read Time + Share Button */}
				<div className="ml-[8px] flex flex-row items-center gap-6 mt-8">
					{/* Calendar + Date */}
					<div className="flex flex-row items-center gap-2">
						<img
							loading="lazy"
							decoding="async"
							src="/assets/blog-details/calendar.svg"
							alt="Calendar"
							className="w-[24px] h-[24px]"
						/>
						<span className="font-montserrat font-normal text-[12px] leading-[100%] text-[#47645D]">
							April 24, 2025
						</span>
					</div>

					{/* Clock + Read Time */}
					<div className="flex flex-row items-center gap-2">
						<img
							loading="lazy"
							decoding="async"
							src="/assets/blog-details/clock.svg"
							alt="Clock"
							className="w-[24px] h-[24px]"
						/>
						<span className="font-montserrat font-normal text-[12px] leading-[100%] text-[#47645D]">
							Read Time: 9 minutes
						</span>
					</div>

					{/* Share Button */}
					<button className="flex flex-row items-center justify-center gap-2 w-[135px] h-[32px] px-[8px]  rounded-[24px] bg-[#B7D974]">
						<img
							loading="lazy"
							decoding="async"
							src="/assets/blog-details/share.svg"
							alt="Share"
							className="w-[16px] h-[16px]"
						/>
						<span className="font-montserrat font-medium text-[13px] leading-[24px] text-[#193D34]">
							Share
						</span>
					</button>
				</div>
			</div>

			<ImageTextSection type="desktop" />

			<div className="relative flex flex-col w-full max-w-[1300px] h-[476px] mt-[50px] mx-auto rounded-[5px]  hidden lg:flex">
				{/* Center aligned heading */}
				<h2 className="text-[13px] font-semibold leading-[1] text-center text-[#193D34] font-['Montserrat']">
					Interesting Articles
				</h2>

				{/* Cards container */}
				<div className="flex flex-col-2 gap-10 mt-4">
					{interestingArticles.map((card) => (
						<Card key={card.id} content={card} variant="interestingArticles" />
					))}
				</div>
			</div>
			{/* Mobile view */}

			<ImageBanner type="mobile" title="Article" />
			<div className="w-full mx-auto rounded-[5px] flex lg:hidden flex-col gap-4 mt-4 px-4">
				{/* Row 1: Back + Breadcrumbs */}
				<div className="flex flex-col gap-1">
					<div className="flex items-center gap-2">
						<div className="w-fit h-[32px] flex items-center">
							<img
								loading="lazy"
								decoding="async"
								src="/assets/blog-details/arrow.svg"
								alt="Back"
								className="w-[16px] h-[16px]"
							/>
							<span className="font-montserrat text-[13px] font-medium leading-[24px] text-center">
								Back
							</span>
						</div>
					</div>

					<div className="flex flex-wrap items-center gap-1 text-[12px]">
						<span className="font-montserrat font-normal text-black">
							Electronic
						</span>
						<img
							loading="lazy"
							decoding="async"
							src="/assets/search/Icons/bread_crum_arrow.svg"
							className="w-[10px] h-[10px]"
							alt="Electronic"
						/>
						<span className="font-montserrat font-normal text-black">
							Gadgets
						</span>
						<img
							loading="lazy"
							decoding="async"
							src="/assets/search/Icons/bread_crum_arrow.svg"
							className="w-[10px] h-[10px]"
							alt="Gadgets"
						/>
						<span className="font-montserrat font-normal text-black whitespace-nowrap">
							Smart Watches
						</span>
					</div>
				</div>

				{/* Row 2: Headings */}
				<div className="flex flex-col gap-1">
					<h1 className="font-montserrat font-extrabold text-[20px] text-[#193D34] leading-tight">
						Discovering Retail Arbitrage Dropshipping:
					</h1>
					<h1 className="font-montserrat font-extrabold text-[20px] text-[#193D34] leading-tight">
						Leveraging Data-Driven Insights
					</h1>
				</div>

				{/* Row 3: Date + Read Time + Share */}
				<div className="flex flex-col gap-3">
					<div className="flex items-center gap-2">
						<img
							loading="lazy"
							decoding="async"
							src="/assets/blog-details/calendar.svg"
							className="w-[20px] h-[20px]"
							alt="DateTime"
						/>
						<span className="font-montserrat text-[12px] text-[#47645D]">
							April 24, 2025
						</span>
					</div>
					<div className="flex items-center gap-2">
						<img
							loading="lazy"
							decoding="async"
							src="/assets/blog-details/clock.svg"
							className="w-[20px] h-[20px]"
							alt="ReadTime"
						/>
						<span className="font-montserrat text-[12px] text-[#47645D]">
							Read Time: 9 minutes
						</span>
					</div>
					<button className="flex items-center justify-center gap-2 w-[135px] h-[32px] rounded-[24px] bg-[#B7D974]">
						<img
							loading="lazy"
							decoding="async"
							src="/assets/blog-details/share.svg"
							className="w-[16px] h-[16px]"
							alt="Share"
						/>
						<span className="font-montserrat font-medium text-[13px] text-[#193D34]">
							Share
						</span>
					</button>
				</div>
			</div>
			<ImageTextSection type="mobile" />

			<div className="relative flex flex-col w-full px-4 py-6 mt-6 rounded-[5px] flex lg:hidden">
				{/* Center aligned heading */}
				<h2 className="text-[13px] font-semibold leading-[1] text-center text-[#193D34] font-['Montserrat']">
					Interesting Articles
				</h2>

				{/* Cards container */}
				<div className="grid grid-cols-1 gap-4 mt-4">
					{interestingArticles.map((card) => (
						<Card
							key={card.id}
							content={card}
							variant="interestingArticlesMobile"
						/>
					))}
				</div>
			</div>
			<Footer />
		</>
	);
};

export default BlogDetails;
